import { copyTextToClipboard } from "../../utils/copyToClipboard";
import { V3Button, V3ButtonColor } from "../Button";
import { ShareLinkRowInput, ShareLinkRowItemWrapper } from "./ShareLinkRow.styles";

interface ShareLinkRowProps {
    fullLink: string;
    onEditLink: () => void;
    btnLabel?: string;
}

export const ShareLinkRow = ({ fullLink, btnLabel = "Edit link", onEditLink }: ShareLinkRowProps) => {
    return (
        <ShareLinkRowItemWrapper>
            <div
                onClick={() => {
                    copyTextToClipboard(fullLink);
                }}
            >
                <ShareLinkRowInput
                    placeholder="your_custom_url"
                    value={fullLink.replace("https://", "").replace("http://", "")}
                    name="profileCustomShareLink"
                    readOnly
                    maxLength={200}
                />
            </div>
            <div>
                <V3Button
                    text="Copy link"
                    autoWidth
                    color={V3ButtonColor.secondary}
                    onClick={() => {
                        copyTextToClipboard(fullLink);
                    }}
                    type="button"
                />
            </div>
            <div>
                <V3Button text={btnLabel} autoWidth color={V3ButtonColor.secondary} onClick={onEditLink} type="button" />
            </div>
        </ShareLinkRowItemWrapper>
    );
};
